import Accordion from '../../../Accordion/Accordion';
import List from '../../../List/List';
import {subjectFilterList as list} from './content';
import StyledSubject from './styles';
import Props from './typings';

export const getSubjectTitle = (selectedSubjects) => {
  const titleArray: string[] = [];

  if (!!selectedSubjects.length) {
    const lookupValue = selectedSubjects[0].value;
    const selectedOption = list.options.find((option) => option.value === lookupValue);
    if (selectedOption) titleArray.push(selectedOption.label);
  }
  return {label: titleArray, count: selectedSubjects.length};
};

const Subject = ({
  selected,
  subjectCallback,
  collapsible = false,
  defaultCollapsed = false,
}: Props) => {
  const title = 'Subject';
  const subtitle = 'Are you more into abstracts or landscapes?';

  const fragmentBody = () => (
    <List
      options={list.options}
      type={list.type}
      style={list.style}
      group="subject"
      selected={selected}
      callback={subjectCallback}
    />
  );

  const collapsibleFragment = () => (
    <Accordion title={title} subtitle={subtitle} defaultCollapsed={defaultCollapsed}>
      {fragmentBody()}
    </Accordion>
  );

  const fragment = () => (
    <StyledSubject>
      <h4>{title}</h4>

      <p>{subtitle}</p>

      {fragmentBody()}
    </StyledSubject>
  );

  return collapsible === true ? collapsibleFragment() : fragment();
};

export default Subject;
